import { brandConfig } from '../config.js';

export function initRoleGuard() {
  const role = brandConfig.role || 'student';
  document.querySelectorAll('[data-role]').forEach(el => {
    const allowed = el.dataset.role.split(',').map(r => r.trim());
    if (!allowed.includes(role)) {
      el.hidden = true;
    }
  });
}
